import React, { useState } from "react";
import { Tag, Tooltip, Image, Flex, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import CustomTable from "../../Component/Table";
import { getAllPlan, getFeatureData } from "../../Services/subscription";
import { FilterContainer } from "../../Styles/filterStyle";
import DebouncedInput from "../../Component/DebouncedInput";
import ViewModal from "./ViewModal";

// CreditSubscriptionPlans shape (app/models/credit_subscription.py) - flat
// price/currency_code + credit_cap/duration_days, no monthly/yearly cost or
// capped-usage concept (that's per-user now, see monthly credit limit).
// Editing isn't wired up yet - no backend write endpoint exists for this
// table (only get_credit_plan_list/features are read-only so far).
const columns = (handleViewClick) => [
  {
    title: "Plan ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Plan Slug",
    dataIndex: "plan_slug",
    key: "plan_slug",
  },
  // {
  //   title: "Badge",
  //   dataIndex: "full_badge_url",
  //   render: (image) => (
  //     <Image
  //       src={image}
  //       width={40}
  //       height={40}
  //       preview={false}
  //       fallback="https://via.placeholder.com/50"
  //     />
  //   ),
  // },
  // {
  //   title: "Price",
  //   dataIndex: "price",
  //   key: "price",
  //   render: (price, record) => `${record.currency_code || "$"} ${price}`,
  // },
  {
    title: "Credit Cap",
    dataIndex: "credit_cap",
    key: "credit_cap",
  },
  // {
  //   title: "Duration (Days)",
  //   dataIndex: "duration_days",
  //   key: "duration_days",
  //   render: (text) => text || "-",
  // },
  // {
  //   title: "Default Plan",
  //   dataIndex: "is_default_plan",
  //   key: "is_default_plan",
  //   render: (is_default_plan) => (
  //     <Tag color={is_default_plan ? "green" : "red"}>
  //       {is_default_plan ? "Yes" : "No"}
  //     </Tag>
  //   ),
  // },
  {
    title: "Status",
    dataIndex: "is_enable",
    key: "is_enable",
    render: (is_enable) => (
      <Tag color={is_enable ? "green" : "red"}>
        {is_enable ? "Enabled" : "Disabled"}
      </Tag>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Flex gap="small">
        <Tooltip title="View Features">
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => handleViewClick(record)}
          />
        </Tooltip>
      </Flex>
    ),
  },
];

const PlanList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isViewModal, setIsViewModal] = useState(false);
  const [featureData, setFeatureData] = useState(null);

  const { data, isLoading } = useQuery({
    queryKey: ["plans", searchTerm],
    queryFn: () => getAllPlan({ name: searchTerm, isCreditPlan: true }),
    refetchOnWindowFocus: false,
  });

  const handleViewClick = async (plan) => {
    try {
      const features = await getFeatureData(plan.id, true);
      setFeatureData(features); // Save fetched features
      setIsViewModal(true);
    } catch (error) {
      console.error("Error fetching feature data:", error);
    }
  };

  return (
    <div>
      <Flex justify="space-between">
        <h3>Plan List</h3>
      </Flex>
      <br />
      <FilterContainer>
        <DebouncedInput
          placeholder="Search by Name..."
          value={searchTerm}
          onChange={setSearchTerm}
          delay={1000}
        />
      </FilterContainer>

      <CustomTable
        columns={columns(handleViewClick)}
        data={data?.plans || []}
        loading={isLoading}
        pagination={false}
        maxHeight="calc(106vh - 300px)"
      />
      <ViewModal
        isModalVisible={isViewModal}
        handleCancel={() => setIsViewModal(false)}
        initialValues={featureData}
      />
    </div>
  );
};

export default PlanList;
